// Dependencies
import React, {useState} from 'react';
import radium from 'radium';
import '../CheckoutProcess.scss';
import RadioSelection from "../../../components/radioSelection/RadioSelection.tsx";
import moment from "moment";
import ZigZagBox from "../../../components/zig-zag-box/ZigZagBox";
import paymentTypesEnum from '../../../components/payment-type/payment-types-enum';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import ZigZagBoxTitle from "../../../components/zig-zag-boxTitle/ZigZagBoxTitle";
import CheckoutButtons from "../CheckoutButtons";
import {PaymentTypesIconsEnum} from "../../../components/payment-type/payment-types-enum";


interface PP_OVERVIEW_props  {
	checkoutProps: any,
	next: any,
	pop: any,
	reset: any,
	btnLabels?: any
}


function PP_OVERVIEW(props: PP_OVERVIEW_props) {
	const icons:any = PaymentTypesIconsEnum
	const context = React.useContext(ThemeContext)
	const style: any = {
		paymentTypeItem: {
			borderBottom:context.themeManager.value('payment-item',
				'border', 'content-border-bottom'),
			margin: context.themeManager.valueOrDefault('payment-item','margin', null, '2.5em 0 1.5em'),
			padding: context.themeManager.valueOrDefault('payment-item','padding', null, '0 0 1.2em'),
		},
		labelAdditional: {
			fontSize: context.themeManager.value('payment-label-additional',
				'fontSize', 'font-size-80'),
			lineHeight: context.themeManager.value('payment-label-additional',
				'lineHeight', 'line-height-200'),
			visibility: 'hidden'
		},
		paymentTypeImage: {
			margin: '1em 0px 0.6em',
			width: '100%'

		},
		paymentTypeContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center'
		},
		paymentTypeText: {
			marginRight: '.7em',
		},
		radioSelectionLabel: {
			width: '100%',
			marginBottom:'-25px',
			paddingBottom: '1.2em',
			marginTop: '-25px',
			paddingLeft: '1em'
		},
		radioSelectionLabelWithoutImg: {
			width: '100%',
			paddingLeft: '1em',
		}
	};

	// Component State initialized with first payment option (preselected)
	const paymentTypes = Object.entries(props.checkoutProps.output.paymentTypes)
	const defaultPaymentType:any =
		Object.values(props.checkoutProps.output.paymentTypes).filter((pt:any) => pt.availability.isDefault)[0] ||
		Object.values(props.checkoutProps.output.paymentTypes)[0];

	const [selectedPaymentType, setSelectedPaymentType] = useState(defaultPaymentType?.availability?.available ? defaultPaymentType?.method: null);
	const [selectedPaymentProvider, setSelectedPaymentProvider] = useState(defaultPaymentType?.availability?.available ? defaultPaymentType?.provider: null);

	function createPaymentTypeLabel(paymentType:any, availability:any, paymentTypeKey:any) {
		return (
			<div style={style.paymentTypeContainer}>
				{icons[paymentTypeKey] &&
					<div style={style.paymentTypeImage} aria-hidden="true"><img src={icons[paymentTypeKey]} alt={"Logo für Zahlungsart" + paymentType} aria-hidden="true"/></div>
				}
				<div style={style.paymentTypeText}>{paymentType}</div>
				<div style={style.labelAdditional}>{availability}</div>
			</div>
		);
	}
	
	return (
		<div>
			<h1 className="page__headline"
				dangerouslySetInnerHTML={{
					__html: context.themeManager
						.getThemeTextOrHardcodedDefault('paymentProviderOverviewHeadline'),
				}}
			/>
			<ZigZagBox>
				<ZigZagBoxTitle id={"payment_label"}  headlineLevel={"h2"}>
					Bitte wählen Sie eine Zahlungsart:
				</ZigZagBoxTitle>
				{paymentTypes.length > 0 &&
				<ul role="radiogroup" aria-labelledby={"payment_label"}>
					{paymentTypes.map(([key, value]: [string, any], i) => {
						const expired = !value.availability.available;
						const availableUntil = value.availability.availableUntil
						const availableUntilPart = availableUntil ? ` bis ${moment(availableUntil).format('DD.MM.YYYY HH:mm')}`:
							'';
						const availabilityPart =
							expired ?
								'nicht mehr verfügbar' :
								'verfügbar' + availableUntilPart;
						// @ts-expect-error type error
						const label = createPaymentTypeLabel(paymentTypesEnum[key], availabilityPart, key);
						return (
							<li key={i} style={style.paymentTypeItem}>
								<RadioSelection
									name="paymentType"
									value={key}
									onChange={(event:any) => {
										setSelectedPaymentType(event.target.value)
										setSelectedPaymentProvider(props.checkoutProps.output.paymentTypes[`${event.target.value}`].provider)
									}}
									radioGroupValue={selectedPaymentType}
									label={label}
									labelStyle={icons[key] ? style.radioSelectionLabel : style.radioSelectionLabelWithoutImg}
								/>
							</li>)
					})
					}
				</ul>
				}

			</ZigZagBox>
			<CheckoutButtons
				btnResetLabel={props.btnLabels.resetBtnLabel}
				btnNextLabel={props.btnLabels.nextBtnLabel}
				btnBackLabel={props.btnLabels.backBtnLabel}
				onBackClick={()=>props.pop({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				onNextClick={()=>props.next({method: selectedPaymentType, provider: selectedPaymentProvider})}
				onResetClick={()=>props.reset({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
			/>
		</div>
	);
}


const RadiumPP_OVERVIEW = radium(PP_OVERVIEW);


/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
// @ts-expect-error type error
RadiumPP_OVERVIEW["name"] = PP_OVERVIEW.name

export default (RadiumPP_OVERVIEW);
